<script setup lang="ts">
import { EButtonType } from '../models/type';
import ButtonBase from './ButtonBase.vue';
</script>

<template>
  <ButtonBase :type="EButtonType.tetriaryOutlined" v-bind="$attrs">
    <slot />
  </ButtonBase>
</template>
